import EaseChatSDK from 'easemob-websdk'

// 环信SDK实例
const EaseChatClient = new EaseChatSDK.connection({
    appKey: import.meta.env.MODE === 'production' ? '1120240516169440#ganhr' : '1164240702169828#demo',
    url: '//im-api-v2.easemob.com/ws',
    apiUrl: '//a1.easemob.com',
    delivery: true,
})
export { EaseChatSDK, EaseChatClient }